<template>
  <div>
    <el-row :gutter="12">
      <el-col :span="12">
        <el-table v-loading="loading"
                  style="margin-top: 42px;"
                  border
                  ref="table1"
                  height="455px"
                  :data="selections"
                  @selection-change="handleDelSelectionChange">
          <el-table-column type="selection"
                           width="40">
          </el-table-column>
          <el-table-column label="商品批次号"
                           min-width="180"
                           show-overflow-tooltip=""
                           prop="batchCode">
          </el-table-column>
          <el-table-column label="商品名称"
                           min-width="200"
                           show-overflow-tooltip=""
                           prop="productName">
          </el-table-column>
          <el-table-column label="数量"
                           width="60"
                           show-overflow-tooltip=""
                           prop="goodsCount">
          </el-table-column>
          <el-table-column label="操作"
                           width="50">
            <template slot-scope="{ row, $index }">
              <el-button type="text"
                         style="padding: 0"
                         @click="deleteItem(row, $index)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-button type="primary"
                   :disabled="delMultipleSelection.length === 0"
                   style="width: 100%;margin-top: 42px"
                   @click="deletebatch">批量删除（已选择{{ delMultipleSelection.length }} 个）</el-button>
      </el-col>
      <el-col :span="12">
        <el-input placeholder="请输入商品批次号"
                  v-model="query.batchCode"
                  style="width: 280px;margin-bottom: 10px;">
          <el-button slot="append"
                     icon="el-icon-search"
                     @click="handleCurrentChange(1)"></el-button>
        </el-input>
        <el-table v-loading="loading"
                  border
                  ref="table2"
                  height="455px"
                  :data="list"
                  @selection-change="handleAddSelectionChange">
          <el-table-column type="selection"
                           :selectable="row=> !row.isAdded"
                           width="40">
          </el-table-column>
          <el-table-column label="商品批次号"
                           min-width="180"
                           show-overflow-tooltip=""
                           prop="batchCode">
          </el-table-column>
          <el-table-column label="商品名称"
                           min-width="200"
                           show-overflow-tooltip=""
                           prop="productName">
          </el-table-column>
          <el-table-column label="数量"
                           width="60"
                           show-overflow-tooltip=""
                           prop="goodsCount">
          </el-table-column>
          <el-table-column label="操作"
                           width="50">
            <template slot-scope="{ row }">
              <el-button type="text"
                         style="padding: 0"
                         :disabled="row.isAdded"
                         @click="addItem(row)">添加</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination style="text-align:center"
                       background
                       @current-change="handleCurrentChange"
                       :current-page.sync="query.pageNum"
                       :page-size="query.pageSize"
                       layout="total, prev, pager, next"
                       :total="total">
        </el-pagination>
        <el-button type="primary"
                   :disabled="addMultipleSelection.length === 0"
                   style="width: 100%;margin-top: 10px"
                   @click="addbatch">批量添加（已选择{{ addMultipleSelection.length }} 个）</el-button>
      </el-col>
    </el-row>
  </div>
</template>
<script>
export default {
  name: 'attr-table',
  components: { },
  props: {
    config: { type: Object, default () { return { vendorId: null, vendorName: '', productId: null, productName: '' } } }
  },
  data () {
    return {
      loading: false,
      query: { pageNum: 1, pageSize: 10, batchCode: '' },
      total: 0,
      list: [],
      selections: [],
      addMultipleSelection: [],
      delMultipleSelection: []
    }
  },
  watch: {
    selections: {
      handler () {
        this.list = this.countList(this.list)
      },
      deep: true
    },
    config: {
      handler (val, oldVal) {
        if (oldVal.productId && !val.productId) {
          this.reset()
        }
      },
      deep: true
    }
  },
  methods: {
    handleDelSelectionChange (val) {
      this.delMultipleSelection = val
    },
    handleAddSelectionChange (val) {
      this.addMultipleSelection = val
    },
    deleteItem (row, $index) {
      this.selections.splice($index, 1)
    },
    addItem (row) {
      this.selections.push({ ...row })
    },
    deletebatch () {
      const ids = this.delMultipleSelection.map(i => i.batchId)
      this.selections = this.selections.filter(i => !ids.includes(i.batchId))
    },
    addbatch () {
      this.selections.push(...this.addMultipleSelection)
    },
    handleCurrentChange (current) {
      this.query.pageNum = current
      this.fetchList()
    },
    fetchList () {
      this.loading = true
      this.$$BatchApi.getbatchs({ ...this.query, productId: this.config.productId })
        .then(res => {
          const { result, message, total, records } = res.data
          this.loading = false
          if ([0, 13].includes(result)) {
            this.total = total
            this.list = this.countList(records)
          } else {
            this.$message.error(message)
          }
        })
        .catch(err => {
          this.loading = false
          console.log(err)
        })
    },
    countList (list) {
      return list.map(i => ({ ...i, isAdded: this.selections.findIndex(s => s.batchId === i.batchId) > -1 }))
    },
    reset () {
      this.list = []
      this.total = 0
      this.config = { ...this.config, pageNum: 1, pageSize: 10, productName: '' }
      this.selections = []
    },
    getSelections () {
      return this.selections
    }
  }
}
</script>
